import {
  SalesforceFieldMappingLocalData,
  SalesforceSyncTypes,
} from 'module/api/integrations/salesforce/types';
import { faArrowRightArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { syncOptions } from '../use-field-mapping-actions';

export const SyncIcon = ({ value }: { value: SalesforceSyncTypes }) => {
  switch (value) {
    case SalesforceSyncTypes.SyncExternalToNative: {
      return (
        <FontAwesomeIcon
          icon={faArrowRight}
          style={{ color: 'var(--icon-secondary)' }}
        />
      );
    }

    case SalesforceSyncTypes.SyncTwoWay: {
      return (
        <FontAwesomeIcon
          icon={faArrowRightArrowLeft}
          style={{ color: 'var(--icon-secondary)' }}
        />
      );
    }

    case SalesforceSyncTypes.SyncNativeToExternal: {
      return (
        <FontAwesomeIcon
          icon={faArrowLeft}
          style={{ color: 'var(--icon-secondary)' }}
        />
      );
    }

    default: {
      return null;
    }
  }
};

export const getValidSyncOptions = (
  fieldMap: SalesforceFieldMappingLocalData,
) => {
  // ✅ If allowedSyncTypes is provided by backend, use it to filter options
  if (fieldMap.allowedSyncTypes && fieldMap.allowedSyncTypes.length > 0) {
    return syncOptions.filter((option) =>
      fieldMap.allowedSyncTypes?.includes(option.value),
    );
  }

  // Fallback to old logic when allowedSyncTypes is not available
  const isSyncBothWays =
    fieldMap.rocketlaneField?.extra && fieldMap.salesforceField?.extra;
  const isSyncToExternal =
    fieldMap.rocketlaneField?.extra?.isEditable === false;
  const isSyncToNative = fieldMap.salesforceField?.extra === false;

  switch (true) {
    case isSyncBothWays: {
      return syncOptions;
    }
    case isSyncToExternal: {
      return [
        {
          label: SalesforceSyncTypes.SyncNativeToExternal,
          value: SalesforceSyncTypes.SyncNativeToExternal,
        },
      ];
    }
    case isSyncToNative: {
      return [
        {
          label: SalesforceSyncTypes.SyncExternalToNative,
          value: SalesforceSyncTypes.SyncExternalToNative,
        },
      ];
    }
    default: {
      return syncOptions;
    }
  }
};
